import React from "react";
import { rupiah, num, formatDate } from "@/lib/format";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Printer } from "lucide-react";

export function InvoicePrint({ invoice, onClose }) {
  if (!invoice) return null;
  const inv = invoice;
  return (
    <Dialog open={!!invoice} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl">
        <DialogHeader className="sr-only">
          <DialogTitle>Invoice {inv.trx_no}</DialogTitle>
          <DialogDescription>Pratinjau cetak invoice penjualan</DialogDescription>
        </DialogHeader>
        <div id="print-area" className="bg-white text-slate-900" data-testid="invoice-print">
          <div className="flex items-start justify-between border-b-2 border-slate-900 pb-4 mb-4">
            <div>
              <div className="font-display text-2xl font-bold">GudangKu</div>
              <div className="text-xs text-slate-500">Warehouse & Armada Sales</div>
            </div>
            <div className="text-right">
              <div className="font-display text-xl font-bold">INVOICE</div>
              <div className="font-mono text-sm">{inv.trx_no}</div>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4 text-sm mb-4">
            <div>
              <div className="text-xs font-mono uppercase text-slate-500">Pelanggan</div>
              <div className="font-semibold">{inv.customer}</div>
            </div>
            <div className="text-right space-y-0.5">
              <div>Tanggal: <span className="font-mono">{formatDate(inv.date)}</span></div>
              <div>Sales: {inv.sales_name}</div>
              <div>Pembayaran: {inv.payment_method}{inv.payment_method === "Tempo" && inv.due_date ? ` — Jatuh tempo ${formatDate(inv.due_date)}` : ""}</div>
            </div>
          </div>
          <table className="w-full text-sm mb-4">
            <thead>
              <tr className="border-b border-slate-300 text-left text-xs font-mono uppercase text-slate-500">
                <th className="py-1.5">SKU</th><th>Barang</th><th className="text-right">Qty</th><th className="text-right">Harga</th><th className="text-right">Diskon</th><th className="text-right">Subtotal</th>
              </tr>
            </thead>
            <tbody>
              {inv.items.map((it) => (
                <tr key={it.product_id} className="border-b border-slate-100">
                  <td className="py-1.5 font-mono text-xs">{it.sku}</td>
                  <td>{it.name}</td>
                  <td className="text-right font-mono">{num(it.qty)} {it.unit}</td>
                  <td className="text-right font-mono">{rupiah(it.sell_price)}</td>
                  <td className="text-right font-mono">{it.discount ? rupiah(it.discount) : "-"}</td>
                  <td className="text-right font-mono">{rupiah(it.subtotal)}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              {inv.total_discount > 0 && (
                <tr><td colSpan={5} className="py-1 text-right text-sm">Diskon total</td><td className="text-right font-mono">-{rupiah(inv.total_discount)}</td></tr>
              )}
              <tr className="border-t-2 border-slate-900">
                <td colSpan={5} className="py-2 text-right font-bold">TOTAL</td>
                <td className="py-2 text-right font-mono font-bold text-lg">{rupiah(inv.total)}</td>
              </tr>
              {inv.payment_method === "Tempo" && (
                <tr>
                  <td colSpan={5} className="text-right text-xs text-slate-500">Terbayar / Sisa</td>
                  <td className="text-right font-mono text-xs">{rupiah(inv.paid_amount || 0)} / {rupiah(inv.total - (inv.paid_amount || 0))}</td>
                </tr>
              )}
            </tfoot>
          </table>
          <div className="flex justify-between mt-10 text-sm">
            <div className="text-center w-40"><div className="mb-14">Hormat kami,</div><div className="border-t border-slate-400 pt-1">{inv.sales_name}</div></div>
            <div className="text-center w-40"><div className="mb-14">Penerima,</div><div className="border-t border-slate-400 pt-1">{inv.customer}</div></div>
          </div>
        </div>
        <div className="flex justify-end gap-2 print:hidden">
          <Button variant="outline" onClick={onClose}>Tutup</Button>
          <Button onClick={() => window.print()} className="bg-slate-900 hover:bg-slate-800" data-testid="btn-do-print"><Printer className="h-4 w-4 mr-1" />Cetak</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
